export default {
    LOCALE_HTML: {
        'msg.language': 'zh',
        'msg.title': '标题',
        'msg.type': '问题分类',
        'msg.des': '问题描述',
        'msg.phone': '手机号',
        'msg.regionCode': '区号',
        'msg.email': '邮箱',
        'msg.choose': '选择要留言的业务',
        'msg.detail': '留言详情',
        'msg.back': '返回',
        'your.msg': '请您留言',
        'msg.record': '留言记录',
        'msg.success': '留言成功',
        'to.record': '前往留言记录',
        completed: '完成',
        submit: '提交',
        'success.desc': '您的留言已成功提交，感谢您的反馈',
        'msg.form.input': '请输入',
        'msg.reply': '回复',
        'comment.suc': '感谢您的评价！',
        'comment.fail': '提交失败',
        'comment.placeholder': '欢迎给我们的服务提建议',
        'reply.suc': '提交成功！',
        'reply.fail': '请输入您的回复内容',
        'reply.placeholder': '请输入您的回复内容',
        'msg.more': '查看更多',
        'msg.collapse': '收起',
        'msg.myservice': '我的服务评价',
        'msg.evaluate': '服务评价',
        'msg.evaluateTitle': '服务评价',
        'msg.score': '评分：',
        'msg.remark': '评语：',
        'msg.status.created': '已创建',
        'msg.status.pending': '待受理',
        'msg.status.processing': '受理中',
        'msg.status.solved': '已完成',
        'msg.service.reply': '客服回复',
        'msg.my.reply': '您的回复',
        'msg.toast.des': '问题描述为空',
        'msg.toast.type': '问题分类为空',
        'msg.toast.title': '标题为空',
        'msg.toast.none': '不能为空',
        'msg.toast.noAnnex': '请上传附件',
        'msg.toast.noEmail': '邮箱不能为空',
        'msg.toast.noTel': '手机号不能为空',
        'msg.toast.noRegionCode': '区号不能为空',
        'msg.toast.noZone': '请选择时区',
        'msg.toast.noDateTime': '请选择日期时间',
        'msg.toast.email': '请输入正确的邮箱',
        'msg.toast.tel': '请输入正确的手机号',
        'msg.toast.regionCode': '请选择区号',
        'msg.toast.num': '请输入正确的数字',
        'msg.toast.annex': '请上传附件',
        'msg.toast.char': '请输入正确的字符',
        'msg.list.none': '暂无数据',
        'msg.form.choose': '请选择',
        'msg.form.chooseZone': '选择时区',
        'msg.form.chooseTime': '选择时间',
        'msg.form.chooseDate': '选择日期',
        'msg.form.sure': '确定',
        'msg.form.search': '搜索...',
        'msg.form.uploadError': '上传附件格式不符合要求',
        'msg.form.uploadXss': '上传失败，文件内容含有非法脚本',
        'msg.update.time': '更新于',
        'msg.replace.images': '图片',

        MSG016: '已解决',
        MSG017: '未解决',
        MSG019: '提交',
        MSG072: '评价标签不能为空！',
        MSG073: '评价语不能为空！',
        MSG074: '标签:',
        MSG075: '是否解决:',
        MSG076: '请选择问题是否解决',
        MSG015: '该工单是否解决了您的问题？',

        'file.size.limit': '文件大小不能超过50MB',
        'detail.file.limit': '最多15个，大小不超过50M',
        'form.question.des.tip': '请输入问题描述',
        'form.title.tip': '请输入标题',
        'form.class.tip': '请选择问题分类',
        'upload.file': '上传附件',
        'file.count.limit': '最多只能上传15个附件',
        'select.search.placeholder': '搜索关键字',
        'msg.form.sizeError1': '请上传小于5M的附件',
        'msg.form.sizeError2': '请上传小于50M的附件',
        'msg.form.submit': '提交中...',
        'msg.form.upload': '上传中...',
        'msg.email.tip1': '没有查询到您的留言',
        'msg.email.tip2': '如您之前有过留言，可通过邮箱验证查看',
        'msg.email.tip3': '开始邮箱验证',
        'msg.email.noData': '当前账号下暂无数据',
        'email.verify.tip': '输入留言时使用的邮箱地址',
        'email.input.placeholder': '请输入邮箱地址',
        'email.submit': '发送邮件',
        'email.rules.error': '请输入正确的邮箱',
        'email.code.tip': '邮件已发送，请输入您收到的验证码',
        'email.code.placeholder': '请输入验证码',
        'email.code.submit': '立即查看',
        'email.notFind.customer': '未查询到客户信息',
        'email.code.wrong': '验证码错误，请重新输入',
        'email.code.expired': '验证码已过期，请重新验证邮箱',
        'email.code': '验证码',
        'email.send.frequently': '操作过于频繁请稍后再试',
        'comment.fail.400133': '该工单已评价',
        'not.get.user.info': '无法获取您的信息',
        'user.verify.tip': '您需要请通过验证后才能查看留言列表内容',
        'verify.type.email': '邮箱验证',
        'verify.type.phone': '短信验证',
        'verify.text': '验证',
        'cancel.text': '取消',
        'get.verify.code': '获取验证码',
        'reGet.verify.code': '重新获取 ',
        'phone.placeholder': '请输入手机号',
        'verify.by.email.tip': '验证码将通过邮件发送至您输入的邮箱账号中',
        'verify.by.phone.tip': '验证码将通过短信发送至您输入的手机号中 ',
        'phone.error': '请输入正确的手机号',
        'phone.errorCode400150': '验证码发送频繁',
        'phone.errorCode400233': '短信模板不能为空',
        'phone.errorCode400234': '营销短信余额不足',
        'phone.errorCode400235': '通知短信余额不足',
        'phone.errorCode400247': '工单插件短信配置错误',
        'phone.errorCode4400248': '获取短信模板失败',
        'phone.errorCode400249': '该号码非现有用户手机号',
        'phone.errorCode400250': '验证码已过期，请重新获取',
        'msg.you.reply': '回复了您',
        'msg.no.reply':'暂无回复',
    },
    LOCALE_REQUEST: {
        400016: '获取工单信息已过期，请刷新！'
    },
    LOCALE_SYSTEM: {
        MSG004: ({ name }) => `您好，客服${name}接受了您的请求`,
        MSG012: (color) =>
            ` 您可以<span style="color:${color};text-decoration:underline;" class="js-leave-msg">留言</span>`,
        MSG013: '发给客服'
    },
    LOCALE_EDITOR: {
        editor: {
            base: {
                remove: '删除',
                cancel: '取消',
                confirm: '确定',
                inert: '插入',
                width: '宽度',
                height: '高度'
            },
            controls: {
                clear: '清除内容',
                undo: '撤销',
                redo: '重做',
                fontSize: '字号',
                lineHeight: '行高',
                letterSpacing: '字间距',
                textIndent: '段落缩进',
                increaseIndent: '增加缩进',
                decreaseIndent: '减少缩进',
                border: '边框',
                color: '颜色',
                textColor: '文字颜色',
                backgroundColor: '背景颜色',
                tempColors: '临时颜色',
                bold: '加粗',
                italic: '斜体',
                underline: '下划线',
                strikeThrough: '删除线',
                fontFamily: '字体',
                textAlign: '文本对齐',
                alignLeft: '居左',
                alignCenter: '居中',
                alignRight: '居右',
                alignJustify: '两端',
                floatLeft: '左浮动',
                floatRight: '右浮动',
                superScript: '上标',
                subScript: '下标',
                removeStyles: '清除样式',
                headings: '标题',
                header: '标题',
                normal: '常规',
                orderedList: '有序列表',
                unorderedList: '无序列表',
                blockQuote: '引用',
                code: '代码',
                link: '链接',
                unlink: '清除链接',
                hr: '水平线',
                media: '媒体',
                mediaLibirary: '媒体库',
                emoji: '小表情',
                fullscreen: '全屏',
                exitFullscreen: '退出全屏'
            },
            linkEditor: {
                textInputPlaceHolder: '输入链接文字',
                linkInputPlaceHolder: '输入链接地址',
                inputWithEnterPlaceHolder: '输入链接地址并回车',
                openInNewWindow: '在新窗口打开',
                removeLink: '移除链接'
            },
            audioPlayer: {
                title: '播放音频文件'
            },
            videoPlayer: {
                title: '播放视频文件',
                embedTitle: '嵌入式媒体'
            },
            media: {
                image: '图像',
                video: '视频',
                audio: '音频',
                embed: '嵌入式媒体'
            }
        },
        finder: {
            remove: '删除',
            cancel: '取消',
            confirm: '确认',
            insert: '插入所选项目',
            width: '宽度',
            height: '高度',
            image: '图片',
            video: '视频',
            audio: '音频',
            embed: '嵌入式媒体',
            caption: '媒体库',
            dragTip: '点击或拖动文件至此',
            dropTip: '放开鼠标以上传',
            selectAll: '选择全部',
            deselect: '取消选择',
            removeSelected: '删除选中项目',
            externalInputPlaceHolder: '资源名称|资源地址',
            externalInputTip: '使用“|”分隔资源名称和资源地址',
            addLocalFile: '添加本地资源',
            addExternalSource: '添加网络资源',
            unnamedItem: '未命名项目',
            confirmInsert: '插入选中项目'
        }
    }
}
